import React from 'react'
import { MenuList, Typography } from '@material-ui/core'

import { renderRoleNames } from 'commons/roleName'

import StatusChip from 'app/componentV4/Status/Chip'
import Avatars from 'app/componentV4/Avatar/Avatars'
import MoreVertMenu from 'app/componentV4/Menu/MoreVertMenu'
import * as statusColors from 'app/constants/statusColors'

import Delete from 'app/main/settings/teamMembersV4/Action/Delete'
import ReStore from 'app/main/settings/teamMembersV4/Action/ReStore'
import Suspend from 'app/main/settings/teamMembersV4/Action/Suspend'
import ReInvited from 'app/main/settings/teamMembersV4//Action/ReInvited'
import { handleText } from 'app/main/settings/teamMembersV4/useTeamMember'
import {
  ACTIVE,
  INVITED,
  SUSPENDED,
  RE_STORE,
  RE_INVITE,
  SUSPEND,
  DELETE,
  INACTIVE,
} from 'app/main/settings/teamMembersV4/constants'

const handleType = (type) => {
  switch (type) {
    case INACTIVE:
      return statusColors.INACTIVE
    case ACTIVE:
      return statusColors.NORMAL
    case INVITED:
      return statusColors.ACCENT
    case SUSPENDED:
      return statusColors.DISTRESS
    default:
      return statusColors.NORMAL
  }
}

const renderPhoneNumber = (countryCode, phoneNumber) => {
  return phoneNumber ? `${countryCode}${phoneNumber}` : null
}

export const ColumnOfData = (
  formatMessage,
  onAction,
  isRootAdmin,
  setSelectedRow,
) => [
  {
    header: formatMessage({ id: 'firstName.label' }),
    accessor: 'firstName',
    style: { width: '200px' },
    sort: true,
    render: (row) => (
      <div className="flex space-x-3">
        <Avatars
          id={row.id}
          name={`${row.firstName} ${row.lastName}`}
          src={row.avatar}
          characters={row.avatarCharacters}
          className={'w-32 h-32 text-14 font-bold'}
        />
        <Typography className="my-auto">{row.firstName}</Typography>
      </div>
    ),
  },
  {
    header: formatMessage({ id: 'lastName.label' }),
    accessor: 'lastName',
    style: { width: '200px' },
    sort: true,
    render: (row) => (
      <Typography className="my-auto">{row.lastName}</Typography>
    ),
  },
  {
    header: formatMessage({ id: 'teamMembers.table.roles.label' }),
    accessor: 'roles',
    style: { width: '230px' },
    render: (row) => renderRoleNames(row),
  },
  {
    header: formatMessage({ id: 'email.address.label' }),
    accessor: 'email',
    style: { width: '230px' },
    sort: true,
  },
  {
    header: formatMessage({ id: 'phone.label' }),
    accessor: 'phone',
    style: { width: '150px' },
    sort: true,
    render: (row) => renderPhoneNumber(row?.countryCode, row?.phoneNumber),
  },
  {
    header: formatMessage({ id: 'text.status' }),
    accessor: 'status',
    style: { width: '100px' },
    sort: true,
    render: (row) => (
      <StatusChip
        type={handleType(row.status)}
        label={handleText(formatMessage, row.status)}
      />
    ),
  },
  {
    header: '',
    action: true,
    render: (row) => (
      <>
        {isRootAdmin(row.id) ? null : (
          <MoreVertMenu open={(bool) => setSelectedRow(bool ? row : null)}>
            {(closeMenu) => (
              <MenuList className="w-fit">
                {row.status === INVITED && (
                  <ReInvited
                    closeMenu={() => closeMenu()}
                    onAction={() => onAction(RE_INVITE, row.id)}
                  />
                )}
                {row.status === ACTIVE && (
                  <Suspend
                    closeMenu={() => closeMenu()}
                    onAction={() => onAction(SUSPEND, row.id)}
                  />
                )}
                {row.status === SUSPENDED && (
                  <ReStore
                    closeMenu={() => closeMenu()}
                    onAction={() => onAction(RE_STORE, row.id)}
                  />
                )}
                <Delete
                  closeMenu={() => closeMenu()}
                  onAction={() => onAction(DELETE, row.id)}
                />
              </MenuList>
            )}
          </MoreVertMenu>
        )}
      </>
    ),
  },
]
